/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
var SmoothScroll = require("smooth-scroll");

window.Vue = require("vue");

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var isNullOrEmpty = require("is-null-or-empty");
import Nav from "./components/Nav.vue";
import TopNav from "./components/property/TopNav.vue";
import FeaturedImages from "./components/property/FeaturedImages.vue";
import Tabs from "./components/property/Tabs.vue";
import MySwiper from "./components/property/MySwiper.vue";
import SellerCard from "./components/property/SellerCard.vue";
import PublishedOpenHouse from "./components/property/PublishedOpenHouse.vue";
import VideoComponent from "./components/property/VideoComponent.vue";
import SocialShare from "./components/property/SocialShare.vue";
import SignupForm from "./components/property/SignUpForm";
import { Errors, Form } from "./Form";
import VModal from "vue-js-modal";

Vue.use(VModal);
if ($("#app").length) {
    const app = new Vue({
        el: "#app",
        components: {
            ApplicationNav: Nav,
            TopNav,
            FeaturedImages,
            Tabs,
            MySwiper,
            SellerCard,
            PublishedOpenHouse,
            VideoComponent,
            SocialShare,
            SignupForm
        },
        methods: {
            openModal(e) {
                this.setGalleryIndex(e.target.getAttribute("data"));
                // this.setGalleryIndex(e.target.id);
                this.galleryModalClass = "is-active";
            },
            openVideoModal(o) {
                this.videoModalClass = "is-active";
                this.video = o;
            },
            onSubmit() {
                var url = "/property/" + slug + "/submit-contact";
                this.form
                    .submit("post", url, this.$data.form)
                    .then(response => {
                        this.form = new Form({
                            email: "",
                            message: "",
                            captcha: ""
                        });
                        this.message = response.message;
                        $("#captcha-image")[0].src = response.captcha_image;
                    });
            },
            setGalleryIndex(id) {
                this.currentGalleryIndex = _.findIndex(this.gallery, image => {
                    return image.id == id;
                });
            },
            getLightboxImage(property) {
                var imageGallery = this.gallery;
                if (
                    !isNullOrEmpty(this.currentGalleryIndex) &&
                    imageGallery.length > 0
                ) {
                    return imageGallery[this.currentGalleryIndex][property];
                } else {
                    return "";
                }
            },
            previousModalImage() {
                if (this.currentGalleryIndex > 0) {
                    --this.currentGalleryIndex;
                }
            },
            nextModalImage() {
                if (this.currentGalleryIndex < this.gallery.length - 1) {
                    ++this.currentGalleryIndex;
                }
            },
            closeVideoModal() {
                (this.video = {}), (this.videoModalClass = "");
            }
        },
        computed: {
            hasVideos() {
                return typeof this.property.videos !== "undefined" &&
                    this.property.videos.length > 0
                    ? true
                    : false;
            },
            showOpenHouse() {
                return this.property.openhouse == "1" &&
                    this.property.openhouses.length
                    ? true
                    : false;
            },
            getLightboxImageSrc() {
                return this.getLightboxImage("lightbox");
            },
            getLightboxImageTitle() {
                return this.getLightboxImage("title");
            },
            getLightboxImageAlt() {
                return this.getLightboxImage("alt");
            },
            getLightboxImageId() {
                return this.getLightboxImage("id");
            },
            isVimeo() {
                if (!isNullOrEmpty(this.video.type)) {
                    return this.video.type == "vimeo";
                }
            },
            isYoutube() {
                if (!isNullOrEmpty(this.video.type)) {
                    return this.video.type == "youtube";
                }
            },
            vimeoUrl() {
                return (
                    "https://player.vimeo.com/video/" +
                    this.video.data.substring(6) +
                    "/?autoplay=1"
                );
            },
            youtubeUrl() {
                return (
                    "https://www.youtube.com/embed/" +
                    this.video.data.substring(6) +
                    "?version=3&rel=0&modestbranding=1&autoplay=1&controls=0&loop=1&playsinline=1"
                );
            }
        },
        mounted() {
            if (this.publish == "yes") {
                axios
                    .get("/api/property/" + this.slug + "/getData")
                    .then(response => {
                        this.property = response.data.property;
                    });
            } else {
                if (typeof propertyToken !== "undefined") {
                    axios
                        .get(
                            "/dashboard/property/" + propertyToken + "/getData"
                        )
                        .then(response => {
                            this.property = response.data.property;
                        });
                }
            }
            var self = this;
            window.addEventListener("scroll", function() {
                self.showBackToTop =
                    window.scrollY / $(document).height() > 0.3;
            });
            var scroll = new SmoothScroll('a[href*="#"]', {});
        },
        created() {
            this.publish = publish;
            this.slug = slug;
            if (typeof propertyToken !== "undefined" || this.slug) {
                this.gallery = _.map($(".gallery img"), function(image) {
                    return {
                        id: image.id,
                        title: image.title,
                        src: image.src,
                        lightbox: image.getAttribute("lightbox"),
                        alt: image.alt
                    };
                });
            }
            this.form = new Form({
                email: "",
                message: "",
                captcha: ""
            });
        },
        data: {
            form: null,
            property: {
                featuredImages: [],
                highlights: [],
                description: "",
                sellerStatement: "",
                sellerCard: {},
                showForm: 0,
                tweet: "",
                openhouse: false,
                openhouses: []
            },
            status: "",
            message: "",
            currentGalleryIndex: 0,
            gallery: [],
            galleryModalClass: "",
            videoModalClass: "",
            video: {},
            publish: "no",
            showBackToTop: false
        }
    });
}
if ($("#open-house").length) {
    const openHouseApp = new Vue({
        el: "#open-house",
        components: {
            SignupForm
        },
        computed: {},
        methods: {},
        data: {}
    });
}

/*
TODO: https://laravel.com/docs/6.x/mix#vendor-extraction // extracted is MUCH MUCH larger filesizes
TODO: swiper is a little buggy. see if its a situation of too few photos.
*/
